export default class StripeToken {
  readonly last4: string
  readonly expMonth: number
  readonly expYear: number


  constructor(data: { [key: string]: any }) {
    this.last4 = data.last4
    this.expMonth = data.expMonth
    this.expYear = data.expYear
  }
}
